// extracted by mini-css-extract-plugin
export default {"head":"goBack_head__lF1Kg","arrow":"goBack_arrow__uF9U7","back":"goBack_back__OlyEQ"};